import Image from "next/image";
import Link from "next/link";
import { getButtonVariantStylesAndSize, ButtonVariantTypes } from "components/ui/button";

const CtaBox = ({
  title,
  subHeader,
  ctaText,
  ctaUrl,
  disclaimerText,
  footerIcon,
  footerTitle,
  sections = [],
  titleTag = "p"
}: {
  title: string;
  subHeader: string;
  ctaText: string;
  ctaUrl: string;
  disclaimerText: string;
  footerIcon: string;
  footerTitle: string;
  sections: {
    valueIcon: string;
    valueCopy: string;
  }[];
  titleTag?: React.ElementType;
}) => {
  const TitleTag = titleTag;

  return (
    <section id="CtaBox-52" className="@container">
      <section className="bg-brand px-3 py-20 @2xl:px-20 @2xl:py-32">
        <div className="m-auto max-w-[768px] overflow-hidden rounded-3xl">
          <div className="flex flex-col justify-center bg-offwhite px-5 py-20 @2xl:p-20">
            <div className="w-full">
              <TitleTag className="mb-5 text-center font-heading text-4xlt text-primary-700 @3xl:text-5xlt">
                {title}
              </TitleTag>
              <p className="mb-10 text-center font-matter text-lg text-primary-700">
                <>{subHeader}</>
              </p>

              <div className="mb-5 text-center">
                <Link
                  href={ctaUrl}
                  prefetch={false}
                  className={getButtonVariantStylesAndSize({ variant: ButtonVariantTypes.BRAND, size: "xl" })}
                >
                  {ctaText}
                </Link>
              </div>
              {!!disclaimerText && <p className="text-center text-sm text-primary-700">{disclaimerText}</p>}
            </div>
          </div>
          <div className="m-auto w-full bg-[#EBE9DE] p-10 @2xl:p-16">
            <div className="w-full">
              <div className="mb-6 flex flex-col items-center justify-center gap-5 text-center @2xl:flex-row">
                {!!footerIcon && (
                  <Image src={footerIcon} width={48} height={48} alt="Award-winning" className="h-12 w-12" />
                )}
                <p className="text-xl font-medium">{footerTitle}</p>
              </div>

              <div className="grid grid-cols-1 gap-2 text-primary-700 @3xl:grid-cols-3">
                {Array.isArray(sections) &&
                  sections?.map((section, index) => (
                    <div
                      className="flex flex-col items-center justify-center rounded-2xl bg-offwhite px-5 py-8"
                      key={index}
                    >
                      <Image
                        src={section.valueIcon}
                        width={48}
                        height={48}
                        alt="Price Promise"
                        className="mb-5 h-12 w-12"
                      />
                      <p className="mx-auto max-w-[180px] text-center text-sm text-primary-700">{section.valueCopy}</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default CtaBox;
